<template>
  <div id="library" class="column is-12">
    <loader :loading="loading" :fixed="false" :key="loading"></loader>
    <div v-for="(theme, idx) in themes" :key="idx">
      <div class="columns is-vcentered">
        <div class="column is-6">
          <img :src="getImage(theme)"/>
        </div>
        <div class="column is-6">
          <h1 class="title is-1">{{theme.Title}}</h1>
          <h2 class="subtitle is-4">{{theme.Subtitle}}</h2>
          <a class="button is-primary" href="#" @click.prevent="function(){ toggleTheme(idx) }">
            <span>Lees meer</span>
            <span class="icon">
              <transition name="fade" mode="out-in">
                <font-awesome-icon :key="new Date().getTime()" :icon="showTheme[idx] ? icons.up : icons.down" />
              </transition>
            </span>
          </a>
        </div>
      </div>
      <home-theme :show="showTheme[idx]" :theme="theme" ref="theme" v-on:close-theme="function(){ toggleTheme(idx, true) }"></home-theme>
    </div>
  </div>
</template>

<script>

import homeTheme from '@/components/custom/Theme.vue'
import loader from '@/components/Loader.vue'
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'library',
  data () {
    return {
      showTheme: [],
      icons: {
        down: faChevronDown,
        up: faChevronUp
      },
      loading: true,
      lightboxSrc: ''
    }
  },
  mixins: [],
  components: {
    homeTheme,
    loader
  },
  computed: {
    themes () {
      var self = this
      var tmp = []
      if (self.$store.state.themes.length > 0) {
        self.$store.state.themes.forEach(theme => {
          if (self.$store.state.language === theme.Culture) {
            tmp.push(theme)
          }
        })
      }
      return tmp
    }
  },
  methods: {
    setThemes: function () {
      var self = this

      self.$store.dispatch('getThemes', false).then(function () {
        self.showTheme = Array(self.$store.state.themes.length).fill(false)
        self.loading = false
      })
    },
    getImage: function (theme, full) {
      full = full || false
      if (full && theme.ImageLarge === '') {
        return ''
      }
      if (theme.Image !== '') {
        return this.$store.state.imgBase + (full && theme.ImageLarge !== '' ? theme.ImageLarge : theme.Image)
      } else {
        return ''
      }
    },
    toggleTheme (idx, close) {
      close = close || false
      var tmp = this.showTheme.slice()
      tmp[idx] = close ? false : !tmp[idx]
      this.showTheme = tmp
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted () {
    var self = this
    self.setThemes()
  },
  watch: {
    '$store.state.isAdmin': {
      handler: function (val) {
        var self = this
        self.$store.commit('setThemes', [])
        self.setThemes()
      },
      immediate: false
    }
  }
}
</script>

<style lang="scss" scoped>
  #library{
    >div{
      margin-bottom: 20px;
      .is-vcentered{
        img{
          border: 1px solid $grey;
        }
      }
      @media screen and (max-width: $bp-tablet - 1px){
        .title{
          font-size: 2.75rem;
        }
        .subtitle{
          font-size: 1.25rem;
        }
      }
    }

  }
</style>
